/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS')
  .directive('zcsMakerepeaterOnly', zcsMakerepeaterOnlyDirective);

zcsMakerepeaterOnlyDirective.$inject = ['ZcsOemService'];
function zcsMakerepeaterOnlyDirective(ZcsOemService) {
  return {
    restrict: 'A',
    link(scope, elem, attrs) {
      scope.ZcsOemService = ZcsOemService;
      scope.$watch('ZcsOemService.get()', oemService => {
        if(oemService === 'makerepeater') {
          elem.css({display: 'block'});
        } else {
          elem.css({display: 'none'});
        }
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/makerepeater_only/makerepeater_only.directive.js